import { rgba, tint } from 'helpers/color';

const primitiveColors = {
    color1: '#000',
    color2: '#7c7c7c',
    color3: '#b8b8b8',
    color4: '#ececec',
    color5: '#f6f6f6',
    color6: 'var(--color-brand-blue-1)',
    color7: '#00b2e2',
    color8: '#78D289',
    color9: '#ffda0c',
    color10: '#e12a44',
    color11: 'var(--color-club-matas-1)',
    color16: 'var(--color-spot-1)',
    color17: 'var(--color-nordic-grey-1)',
    color18: 'var(--color-club-matas-3)',
    color19: '#e6d5c8',
    color20: 'var(--color-advice-1)',
    color21: '#f49d75',
    color22: 'var(--color-subscription-1)',
    color23: '#708472', // unused
    color24: 'var(--color-men-1)',

    positive: 'var(--color-neutral-black)',
    negative: 'var(--color-neutral-white)'
};

const namedColors = {
    transparent: 'transparent', // unused
    currentColor: 'currentColor', // unsued
    primary: '#000',
    secondary: '#e7ebf0',
    tertiary: '#e2e4e6',
    quaternary: primitiveColors.color5,
    quinary: primitiveColors.color3, // unused

    ctaPrimary: '#000',
    ctaSecondary: '#f769ae',
    ctaTertiary: '#ffcc33', // unused
    ctaQuaternary: '#000000',
    ctaQuinary: '#d70081',
    ctaSenary: '#dc9494', // unused

    brand1: primitiveColors.color6, // logo
    brandSecondary: tint(0.1, primitiveColors.color6), // unused

    clubmatas1: primitiveColors.color11,
    clubmatas2: primitiveColors.color6,
    clubmatasFont: primitiveColors.color6,
    clubmatasBackground: tint(0.9, primitiveColors.color11),

    matasPlus: '#C79B4C', // needs primitiveColor

    subscription: primitiveColors.color22,

    points: primitiveColors.color11,

    sampleBackground: tint(0.9, primitiveColors.color24),
    myProfileBackground: tint(0.7, primitiveColors.color17),
    myProfileBackground2: tint(0.4, primitiveColors.color17),
    myProfileBackground3: tint(0.6, primitiveColors.color17),

    buttonPrimary: primitiveColors.positive,
    buttonSecondary: primitiveColors.color4,
    buttonTertiary: primitiveColors.positive,
    buttonQuaternary: primitiveColors.negative,

    backgroundPrimary: primitiveColors.negative, // unused
    backgroundSecondary: '#eee', // unused
    backgroundTertiary: '#fffae0', // unused
    backgroundQuaternary: '#c1e2eb', // unused
    backgroundSeptenary: primitiveColors.color6, // unused
    backgroundQuinary: primitiveColors.color5, // unused
    backgroundSenary: primitiveColors.color4, // unused

    borderPrimary: primitiveColors.color3,
    borderSecondary: '#e2e4e6',
    borderTertiary: primitiveColors.positive,
    borderQuaternary: primitiveColors.color7,
    borderQuinary: '#4a4a4a',
    borderSenary: primitiveColors.color4,
    borderSeptenary: primitiveColors.color6,
    borderOctonary: '#979797',
    borderNonary: primitiveColors.color2,
    borderGrey: primitiveColors.color3, // unused

    linePrimary: tint(0.6, primitiveColors.color17),

    error: primitiveColors.color10,
    errorLight: tint(0.9, primitiveColors.color10),
    success: primitiveColors.color8,
    successLight: tint(0.9, primitiveColors.color8),
    warning: primitiveColors.color9, // unused
    warningLight: tint(0.9, primitiveColors.color9),

    favoriteBackground: '#F8E7D5',

    shadow: rgba(primitiveColors.positive, 0.1),
    boxShadow: rgba(primitiveColors.color20, 0.4),

    storiesBackgroundPrimary: tint(0.6, primitiveColors.color19),
    storiesFontColorTertiary: '#a69189',

    stylebox: '#C2C0CA',

    facebook: '#1877F2',
    youtube: '#FF0000',

    footerAccordion: tint(0.2, primitiveColors.color6),
    footerBackground: tint(0.8, primitiveColors.color17),

    searchHeader: tint(0.6, primitiveColors.color17),

    pinkBannerBackground: tint(0.4, primitiveColors.color18),
    liveButton: primitiveColors.color18,
    futureLiveEvent: tint(0.7, primitiveColors.color18),
    liveLabel: tint(0.5, primitiveColors.color18),

    activeFilterbackground: rgba(primitiveColors.color24, 0.2),

    fontPrimary: primitiveColors.color1,
    fontSecondary: primitiveColors.color2,
    fontTertiary: '#a9a9a9',
    fontQuaternary: '#f90621', // e.g bundles color
    fontSenary: primitiveColors.color11,
    fontClubmatas: primitiveColors.color6,

    link: primitiveColors.color1,
    link2: primitiveColors.color7,

    prelaunchBackground: tint(0.7, primitiveColors.color11),

    fixedLowPrice: primitiveColors.color21,

    stockHigh: '#0dc730', // green
    stockLow: '#ffda0c', // yellow
    stockNone: primitiveColors.color10, // red

    skontByMatas: '#BA9131',

    protectTheEnvironment: primitiveColors.color8,

    profHairCare: '#bad5d5'
};

export default { ...primitiveColors, ...namedColors };
